/**
 * Community hub: mobile swipe pager + open native social apps on phone.
 */
(function () {
  const APP_FALLBACK_MS = 1400;

  function isMobileSocialClient() {
    return (
      window.matchMedia('(max-width: 749px)').matches ||
      window.matchMedia('(pointer: coarse)').matches
    );
  }

  /**
   * @param {string} platform
   * @param {string} webUrl
   * @returns {string|null}
   */
  function webToAppUrl(platform, webUrl) {
    let url;
    try {
      url = new URL(webUrl);
    } catch {
      return null;
    }

    const host = url.hostname.replace(/^www\./i, '').toLowerCase();
    const path = url.pathname || '/';

    switch (platform) {
      case 'whatsapp': {
        if (host === 'wa.me' || host === 'api.whatsapp.com') {
          const phone = path.replace(/\//g, '').replace(/\D/g, '');
          if (!phone) return null;
          const text = url.searchParams.get('text');
          return text
            ? `whatsapp://send?phone=${phone}&text=${encodeURIComponent(text)}`
            : `whatsapp://send?phone=${phone}`;
        }
        return null;
      }
      case 'instagram': {
        const seg = path.split('/').filter(Boolean)[0];
        if (!seg || ['p', 'reel', 'reels', 'stories', 'explore', 'direct'].includes(seg)) {
          return null;
        }
        return `instagram://user?username=${encodeURIComponent(seg)}`;
      }
      case 'facebook':
        return `fb://facewebmodal/f?href=${encodeURIComponent(url.href)}`;
      case 'linkedin': {
        const linkedInPath = path.startsWith('/') ? path.slice(1) : path;
        if (!linkedInPath) return null;
        return `linkedin://${linkedInPath}${url.search}`;
      }
      case 'tiktok': {
        const at = path.match(/@([^/?#]+)/);
        if (at) {
          return `tiktok://user?username=${encodeURIComponent(at[1])}`;
        }
        return `snssdk1180://webview?url=${encodeURIComponent(url.href)}`;
      }
      case 'youtube': {
        const ytPath = `${host}${path}${url.search}`;
        const isIOS = /iPad|iPhone|iPod/i.test(navigator.userAgent);
        return isIOS ? `youtube://${ytPath}` : `vnd.youtube://${ytPath}`;
      }
      default:
        return null;
    }
  }

  function openAppWithWebFallback(appUrl, webUrl) {
    const started = Date.now();
    window.location.assign(appUrl);
    window.setTimeout(() => {
      if (document.visibilityState === 'visible' && Date.now() - started < APP_FALLBACK_MS + 400) {
        window.location.assign(webUrl);
      }
    }, APP_FALLBACK_MS);
  }

  function initAppLinks(sectionRoot) {
    if (sectionRoot.dataset.uucckCommunityAppsBound === 'true') return;
    sectionRoot.dataset.uucckCommunityAppsBound = 'true';

    if (isMobileSocialClient()) {
      sectionRoot.querySelectorAll('[data-uucck-social-platform]').forEach((link) => {
        link.removeAttribute('target');
      });
    }

    sectionRoot.addEventListener('click', (event) => {
      const link = event.target.closest('[data-uucck-social-platform]');
      if (!link || !sectionRoot.contains(link)) return;
      if (!isMobileSocialClient()) return;

      const platform = link.dataset.uucckSocialPlatform;
      const webUrl = link.dataset.uucckSocialWeb || link.href;
      const appUrl = webToAppUrl(platform, webUrl);
      if (!appUrl) return;

      event.preventDefault();
      openAppWithWebFallback(appUrl, webUrl);
    });
  }

  function initSwipePager(sectionRoot) {
    const track = sectionRoot.querySelector('[data-uucck-community-track]');
    const pager = sectionRoot.querySelector('[data-uucck-community-pager]');
    if (!track || !pager) return;

    const dots = [...pager.querySelectorAll('[data-uucck-community-dot]')];
    const cards = [...track.querySelectorAll('.uucck-home-community__card')];
    if (!dots.length || dots.length !== cards.length) return;

    if (sectionRoot.dataset.uucckCommunityPagerBound === 'true') return;
    sectionRoot.dataset.uucckCommunityPagerBound = 'true';

    function setActive(index) {
      dots.forEach((dot, i) => {
        const active = i === index;
        dot.classList.toggle('is-active', active);
        if (active) {
          dot.setAttribute('aria-current', 'true');
        } else {
          dot.removeAttribute('aria-current');
        }
      });
    }

    function indexFromScroll() {
      const left = track.scrollLeft;
      let best = 0;
      let bestDist = Infinity;
      cards.forEach((card, i) => {
        const dist = Math.abs(card.offsetLeft - left);
        if (dist < bestDist) {
          bestDist = dist;
          best = i;
        }
      });
      return best;
    }

    let scrollTimer;
    track.addEventListener(
      'scroll',
      () => {
        window.clearTimeout(scrollTimer);
        scrollTimer = window.setTimeout(() => setActive(indexFromScroll()), 80);
      },
      { passive: true }
    );

    dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        const i = Number(dot.dataset.uucckCommunityDot);
        const card = cards[i];
        if (!card) return;
        track.scrollTo({ left: card.offsetLeft, behavior: 'smooth' });
        setActive(i);
      });
    });

    setActive(0);
  }

  function initSection(sectionRoot) {
    initSwipePager(sectionRoot);
    initAppLinks(sectionRoot);
  }

  function init() {
    document.querySelectorAll('.uucck-home-community, .uucck-home-useful').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
